import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingCards } from './PricingCards';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50 border-t border-dark-border relative overflow-hidden" data-id="element-98">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-99" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-100">
        <div className="mb-16" data-id="element-101">
          <CountdownTimer data-id="element-102" />
        </div>

        <PricingCards data-id="element-103" />

        <div className="mt-16 flex flex-wrap justify-center items-center gap-6 md:gap-8 text-sm md:text-base text-gray-400" data-id="element-104">
          <div className="flex items-center gap-2" data-id="element-105">
            <Lock className="w-5 h-5 text-gold" data-id="element-106" />
            <span data-id="element-107">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-108">
            <Zap className="w-5 h-5 text-gold" data-id="element-109" />
            <span data-id="element-110">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-111">
            <Shield className="w-5 h-5 text-gold" data-id="element-112" />
            <span data-id="element-113">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2 w-full justify-center mt-4 md:mt-0 md:w-auto" data-id="element-114">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-115" />
            <span data-id="element-116">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}